import { FacetConfig } from "../models/facet.model";

export const ASSET_SEARCH_FACETS: FacetConfig[] = [
    {
        type: 'dropdown',
        config: {
            htmlId: 'assetTypeFacet',
            fieldName: 'assetType',
            fieldTitle: 'Asset Type',
            dataType: 'string'
        }
    },
    {
        type: 'dropdown',
        config: {
            htmlId: 'colorChannelFacet',
            fieldName: 'colorChannel',
            fieldTitle: 'Color Channel',
            dataType: 'string'
        }
    },
    {
        type: 'dropdown',
        config: {
            htmlId: '',
            fieldName: "fileType",
            fieldTitle: "File Type",
            dataType: "string"
        }
    },
    {
        type: 'dropdown',
        config: {
            htmlId: '',
            fieldName: "assetGroupName",
            fieldTitle: "Asset Group",
            dataType: "string"
        }
    },
    {
        type: 'dropdown',
        config: {
            htmlId: '',
            fieldName: "p_cat",
            fieldTitle: "Product Category",
            dataType: "string"
        }
    },
    {
        type: 'range',
        config: {
            htmlId: '',
            fieldName: 'dateAddedEPOCH',
            fieldTitle: 'Date Added',
            dataType: 'number',
            minValue: 0,
            maxValue: 0
        }
    }
];